module.exports = __webpack_public_path__ + "img/hand-paper-alt.80257887.svg";